import Vue from "vue";

if (document.getElementById("accordion")) {
  new Vue({
    delimiters: ["[[", "]]"],
    el: "#accordion",
  });
}
